__turbopack_context__.v({
  "iconButton": "LanguagePicker-module-scss-module__ZEEXKW__iconButton",
  "iconButtonRoot": "LanguagePicker-module-scss-module__ZEEXKW__iconButtonRoot",
  "list": "LanguagePicker-module-scss-module__ZEEXKW__list",
  "listItem": "LanguagePicker-module-scss-module__ZEEXKW__listItem",
  "listItemIcon": "LanguagePicker-module-scss-module__ZEEXKW__listItemIcon",
  "listItemMobile": "LanguagePicker-module-scss-module__ZEEXKW__listItemMobile",
  "listItemRoot": "LanguagePicker-module-scss-module__ZEEXKW__listItemRoot",
  "menuPaper": "LanguagePicker-module-scss-module__ZEEXKW__menuPaper",
  "root": "LanguagePicker-module-scss-module__ZEEXKW__root",
});
